import { useContext, useMemo } from 'react'
import { components } from '@digital-commerce/shared-utils'
import localeContext from '../../../contexts/Locale'

import { getHeaderFooterType } from './utils'
import useCart from '../../../hooks/useCart'

const HeaderFooter = () => {
  const locale = useContext(localeContext)
  const { cart } = useCart()
  const { header, footer } = getHeaderFooterType(cart)

  const renderResult = useMemo(() => {
    return <components.HeaderFooter locale={locale} headerType={header} footerType={footer} />
  }, [locale, header, footer])
  return renderResult
}

export default HeaderFooter
